import type { ReactNode, RefObject } from "react";

import type { IParsedFileData } from "app/pages/digital-marketing/keywords-campaigns/wizard/wizard-pages/adding-keywords-step/ImportCSVModal/types";

export interface ISearchTrackerFromKeywordsTable {
    children: ReactNode;
    selectedRows: string[];
}

export interface ISearchTrackerFromKeywordsTablePopover extends Omit<ISearchTrackerFromKeywordsTable, "children"> {
    isSearchTrackerPopoverOpen: boolean;
    setIsSearchTrackerPopoverOpen: (isOpen: boolean) => void;
    searchTrackerButtonRef: RefObject<HTMLButtonElement>;
}

export enum ICampaignType {
    RankTracker = "Rank Tracker",
    BrandProtection = "Brand Protection",
}

export enum WarningTypes {
    Duplicate,
    DuplicateKeywords,
    KeywordsLimitExceeded,
    CampaignsLimitExceeded,
    Error,
}
export interface IParsedData {
    parsedData: IParsedFileData;
    amountOfNewKeywordsAndScrapingConfs: number;
}
